
// function iconEqHeight(jQClass) {
//     var iconbutton_max = 1;
//     $(jQClass).each(function (index, value) {
//         //Set height to be the biggest number
//         iconbutton_max = ($(this).height() > iconbutton_max) ? $(this).height() : iconbutton_max;
//     });
//     $(jQClass).height(iconbutton_max);
// }


(function ($) {
    $(document).ready(function () {
        // if ($.fn.mediaelementplayer) {
        //     $('video').mediaelementplayer({
        //         alwaysShowControls: true
        //     });
        // }

        // $('.Badging, .Groundtrans').find(".grid").find(".articles").each(function () {
        //     var columnItems = $(this).find(".grid-item");
        //     iconEqHeight(columnItems);
        // });

        // iconEqHeight(".quick-button");
        // $(window).resize(function () {
        //     iconEqHeight(".quick-button");

        //     $('.Badging, .Groundtrans').find(".grid").find(".articles").each(function () {
        //         var columnItems = $(this).find(".grid-item");
        //         iconEqHeight(columnItems);
        //     });
        // });
        //

        $('#Breadcrumbs').prepend('<a href="/" class="breadcrumb-0">Home</a>  &raquo; ');

        // $('#collapseSidebarNav')

    });
})(jQuery);
